/**
 * 用于管理用户信息和团队信息
 */
const state = {
  token: "",
  tokenTimestamp: "",
  invite_id: "",
  user_info: {},
  current_team: {},
};
const mutations = {
  // 通过链接邀请时需要暂时缓存邀请 ID
  setInviteId(state, data) {
    state.invite_id = data;
  },
  //保存个人信息
  setUserInfo(state, user_info) {
    // 团队上下文以 current_team 为准：登录/资料同步（含 ws type=10）返回的 user_info
    // 可能缺字段或携带旧会话快照，若整体覆盖会令 user_info.curr_team_id 与真实当前团队脱节
    const base = user_info || {};
    state.user_info = {
      ...base,
      curr_team_id: state.current_team?.id ?? base.curr_team_id,
      curr_team_name: state.current_team?.team_name ?? base.curr_team_name,
    };
  },
  // 清除登录信息
  CLEAR_AUTH_STATE(state) {
    state.token = "";
    state.tokenTimestamp = "";
    state.invite_id = "";
    state.user_info = {};
    state.current_team = {};
  },
  // 切换团队信息
  CHANGE_TEAM_INFO(state, data) {
    state.user_info.curr_team_id = data.id;
    state.user_info.curr_team_name = data.team_name;
    state.user_info.gpt_model_id = data.gpt_model_id;
    state.user_info.team_storage_id = data.team_storage_id;

    state.current_team = data;
    state.current_team.is_use = 1;
  },
  //保存登录信息
  setToken(state, token) {
    state.token = token;
    state.tokenTimestamp = token ? new Date().getTime() : "";
  },
  // 缓存套餐信息
  setTeamPackage(state, _package) {
    state.user_info.package = _package;
  },
};
const actions = {};
const getters = {
  token: (state) => state.token,
  user_info: (state) => state.user_info,
  current_team: (state) => state.current_team,
  team_storage_id: (state) => state.user_info?.team_storage_id || "",
  global_gpt_model_id: (state) => state.user_info?.gpt_model_id || "",
  current_team_package: (state) => {
    const userinfo = state.user_info;
    if (!userinfo?.package?.package_id) {
      return "";
    } else {
      if (userinfo?.package?.package_type === 2) {
        return "";
      } else {
        return state.user_info?.package?.package_buy_id || "";
      }
    }
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
